import React, { useEffect, useId, ReactNode } from 'react';
import { usePortal } from './PortalProvider';

interface PortalProps {
    children: ReactNode;
}

const Portal = ({ children }: PortalProps) => {
    const { registerPortal, unregisterPortal } = usePortal();
    const portalId = useId();

    useEffect(() => {
        registerPortal(portalId, children);
        return () => unregisterPortal(portalId);
    }, [portalId, children, registerPortal, unregisterPortal]);

    return null;
};

export default Portal;
